import { matchPath, useLocation } from 'react-router-dom';
import { pageRoutes } from 'routes';

export const getCurrentRouteDetails = (pathname: string) => {
  const currentRoute = pageRoutes.private.find(route =>
    matchPath(pathname, {
      path: route.path,
      exact: true
    })
  );

  if (currentRoute) {
    return currentRoute;
  } else {
    const currentRoute = pageRoutes.private.find(route =>
      matchPath(pathname, {
        path: route.path,
        exact: false
      })
    );

    return currentRoute;
  }
};

export const useHeaderTitle = () => {
  const { pathname } = useLocation();
  const currentRoute = getCurrentRouteDetails(pathname);
  return currentRoute?.title ?? '';
};
